import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { Quality, QualityFilters } from '../../models/Quality';

const useQualityService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetQualities, setFetchingGetQualities] = useState(false);
    const [fetchingStoreQuality, setFetchingStoreQuality] = useState(false);
    const [fetchingEditQuality, setFetchingEditQuality] = useState(false);
    const [fetchingUpdateQuality, setFetchingUpdateQuality] = useState(false);
    const [fetchingDeleteQuality, setFetchingDeleteQuality] = useState(false);
    const [fetchingActiveQuality, setFetchingActiveQuality] = useState(false);

    const getQualities = (filters: QualityFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.QUALITIES.GET_QUALITIES}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetQualities
        });
    };

    const storeQuality = (quality: Quality, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.QUALITIES.STORE_QUALITY,
            body: quality,
            requestType: 'json',
            setFetching: setFetchingStoreQuality
        });
    };

    const editQuality = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.QUALITIES.EDIT_QUALITY.replace(':id', id.toString()),
            setFetching: setFetchingEditQuality
        });
    };

    const updateQuality = (id: number, quality: Quality, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.QUALITIES.UPDATE_QUALITY.replace(':id', id.toString()),
            body: quality,
            requestType: 'json',
            setFetching: setFetchingUpdateQuality
        });
    };

    const deleteQuality = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.QUALITIES.DELETE_QUALITY.replace(':id', id.toString()),
            setFetching: setFetchingDeleteQuality
        });
    };

    const activeQuality = (id: number, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.QUALITIES.ACTIVE_QUALITY.replace(':id', id.toString()),
            body: {},
            setFetching: setFetchingActiveQuality
        });
    };

    return {
        fetchingGetQualities,
        fetchingStoreQuality,
        fetchingEditQuality,
        fetchingUpdateQuality,
        fetchingDeleteQuality,
        fetchingActiveQuality,
        getQualities,
        storeQuality,
        editQuality,
        updateQuality,
        deleteQuality,
        activeQuality
    };
};

export default useQualityService;
